/* eslint-disable no-console */
import React from "react";
import { Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { find } from "lodash";
import { Alert, Button, Divider, Form, InputFormWrapper } from "../../atoms";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import {
  InputField,
  InputNumberField,
  LocationSelectedField,
} from "../../molecules";
import {
  listenToAirplaneFromFirestore,
  updateAirplaneInFirestore,
} from "../../../firestore/firestoreService";
import { IAirplaneInput } from "../../../common/types";
import { userFirestoreDoc } from "../../../hooks/useFirestoreDoc";
import { listenToSelectedAirplane } from "../../../redux/data/airplane/airplaneActions";

export const AirplaneDetails: React.FC = () => {
  const [form] = Form.useForm();
  const history = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const { locations } = useSelector((state: any) => state.locations);
  const params = useParams();
  const airplaneId = params.airplaneId || "";
  const dispatch = useDispatch();
  userFirestoreDoc({
    query: () => listenToAirplaneFromFirestore(airplaneId),
    data: listenToSelectedAirplane,
    deps: [dispatch, airplaneId],
    shouldExecute: !!airplaneId,
  });

  const { selectedAirplane } = useSelector((state: any) => state.airplanes);
  const handleSubmit = async () => {
    try {
      const values: IAirplaneInput = await form.validateFields();
      const location = find(locations, ["id", values.locationId]);
      setLoading(true);
      await updateAirplaneInFirestore(airplaneId, {
        name: values.name,
        locationName: location.name,
        locationId: values.locationId,
        maxCapacity: values.maxCapacity,
        status: true,
      });
      setLoading(false);
      history(-1);
    } catch (errorInfo) {
      setLoading(false);
      if (typeof errorInfo === "string") {
        setError(errorInfo.toUpperCase());
      } else if (errorInfo instanceof Error) {
        setError(errorInfo.message);
      }
    }
  };
  React.useEffect(() => form.resetFields);
  return (
    <AdminPageBody>
      {error !== "" && (
        <Alert message={error} type="error" style={{ marginBottom: 20 }} />
      )}
      <InputFormWrapper>
        <div className="input-form-body">
          <Form
            form={form}
            name="horizontal_login"
            layout="vertical"
            autoComplete="off"
            initialValues={selectedAirplane}
          >
            <Divider orientation="left">{selectedAirplane?.name}</Divider>
            <Row gutter={8}>
              <Col span={8} sm={12} xs={24}>
                <InputField
                  label="Airplane Name"
                  name="name"
                  rules={[{ required: true, message: "Missing Airplane Name" }]}
                  placeholder="Airplane Name"
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8} sm={12} xs={24}>
                <LocationSelectedField
                  label="Location"
                  name="locationId"
                  rules={[{ required: true, message: "Missing Type" }]}
                />
              </Col>
              <Col span={8} sm={12} xs={24}>
                <InputNumberField
                  label="Max Capacity"
                  name="maxCapacity"
                  min={0}
                  placeholder="Max Capacity"
                  style={{ width: "100%" }}
                  rules={[{ required: true, message: "Missing Max Capacity" }]}
                />
              </Col>
            </Row>
            <Divider></Divider>
            <Button
              type="primary"
              className="input-form-btn"
              onClick={handleSubmit}
              loading={loading}
            >
              Update Airplane
            </Button>
          </Form>
        </div>{" "}
      </InputFormWrapper>
    </AdminPageBody>
  );
};
